import React from 'react';
import App from './App';

import Account from './pages/Account';
import Authentication from './Authentication';
import Info from './pages/Info';
import Referrals from './pages/Referrals';
import TokenSignIn from './pages/TokenSignIn';

import { INDEX_ROUTE } from './config';
import { Route, IndexRoute } from 'react-router';

module.exports = (
    <Route path={`${INDEX_ROUTE}`} component={App}>
      <IndexRoute component={Account} />      

      <Route path={`${INDEX_ROUTE}/`} component={Account} />
      <Route path={`${INDEX_ROUTE}/signin/:token`} component={TokenSignIn} />
      <Route path={`${INDEX_ROUTE}/signin/:token/:return_url`} component={TokenSignIn} />
      <Route path={`${INDEX_ROUTE}/signout/:subdomain`} component={Account} />
      <Route path={`${INDEX_ROUTE}/signup/:referrallink`} component={Account} />
      <Route path={`${INDEX_ROUTE}/info`} component={Info} />
      <Route path={`${INDEX_ROUTE}/referrals`} component={Referrals} />
      <Route path={`${INDEX_ROUTE}/redirect/:redirect`} component={Authentication} />

    </Route>
)


// WEBPACK FOOTER //
// ./src/routes.js